module.exports = __webpack_public_path__ + "static/media/ask-doubts.bf60c99e.svg";